import React from 'react';
import { Images, AlertCircle } from 'lucide-react';
import ImageBrowser from '../../shared/ImageBrowser';

const PortfolioTab = () => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div>
        <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2">Portfolio Images</h3>
        <p className="text-sm text-gray-600">
          Upload and manage your portfolio images. Showcase your best work to potential clients. Maximum 8 images allowed.
        </p>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 sm:p-6 mb-4 sm:mb-6">
        <div className="flex items-start">
          <AlertCircle className="h-5 w-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
          <div className="min-w-0">
            <h4 className="text-sm font-medium text-blue-900">Portfolio Guidelines</h4>
            <ul className="text-sm text-blue-700 mt-1 space-y-1 list-disc list-inside">
              <li>Maximum 8 portfolio images allowed</li>
              <li>Supported formats: JPEG, PNG, GIF, WebP</li>
              <li>Maximum file size: 10MB per image</li>
              <li>Recommended dimensions: 1200x800px or larger</li>
              <li>Showcase your best work to attract clients</li>
            </ul>
          </div>
        </div>
      </div>

      <ImageBrowser
        imageType="portfolio"
        onSelectImage={null}
        showUpload={true}
        showDelete={true}
        showSetDefault={false}
        maxImages={8}
      />
    </div>
  );
};

export default PortfolioTab;

